<template>
  <div
    class="
      grid
      text-center
      xl:mb-[1vw]
      pb:grid-cols-auto-menu pb:gap-[1vw]
      justify-center justify-items-start
    "
  >
    <Link
      v-for="(hyperLink, key) in hyperLinks1"
      :key="key"
      :href="route(hyperLink.route)"
      class="
        text-xs
        table
        xl:text-[1rem]
        text-gray-600
        hover:underline hover:text-blue-600
      "
    >
      {{ hyperLink.text }}
    </Link>
  </div>
</template>
<script>
import { Link } from "@inertiajs/inertia-vue3";

export default {
  components: {
    Link,
  },
  data() {
    return {
      hyperLinks1: [
        {
          route: "terms",
          text: "Termos de Uso",
        },
        {
          route: "privacy",
          text: "Privacidade",
        },
        {
          route: "faq",
          text: "Perguntas Frequentes",
        },
        {
          route: "contact",
          text: "Fale Conosco",
        },
      ],
    };
  },
};
</script>
